module.exports = __webpack_public_path__ + "static/map_placeholder-black_and_white-9421a7cab65c45ca3037e3a19caf4664.jpg";